/**侧滑菜单***/
<template>
  <div class='sideMenus' v-bind:class="{'showSideMenus':sideMenusState}">
    <div class='sideMenusContent'>
      <div class="personInfo" @click="compileNomFn">
        <div class="personInfo-inner">
          <div class="headImg">
            <img v-if="upImgFn" :src="upImgFn" alt="头像">
            <img v-else="" src="/static/img/default_pic.png" alt="头像">
          </div>
          <p class="vipRank">
            <img src="/static/img/star.png" alt="">{{loginData && loginData.grade ? loginData.grade.grade_name : ''}}
          </p>
        </div>
        <div class="info">
          <h2 class="infoName">{{loginData && loginData.passenger ? loginData.passenger.name : ''}}</h2>
          <p class="infoName">{{loginData && loginData.passenger ? loginData.passenger.enterprise_name : ''}}</p>
          <!--<p class="phone">{{loginData && loginData.passenger && loginData.passenger.phone ? loginData.passenger.phone.replace(/(\d{3})(\d{4})(\d{4})/, '$1****$3') : ''}}</p>-->
        </div>
      </div>
      <div class="menusOption">
        <ul>
          <li @click="sideMenusFn">
            <router-link to="/orderRecord"><img class="icon" src="/static/img/order.png" alt=""><span
              class="text">我的订单</span>
            </router-link>
            <img class="arrows" src="/static/img/arrows.png" alt="">
          </li>
          <li @click="sideMenusFn">
            <router-link :to="'/mewallet'"><img class="icon" src="/static/img/wallet.png" alt=""><span class="text">我的钱包</span>
            </router-link>
            <img class="arrows" src="/static/img/arrows.png" alt="">
          </li>
          <li @click="sideMenusFn">
            <router-link :to="'/qrCode'"><i class="iconfont icon-erweima"></i><span class="text">我的二维码</span>
            </router-link>
            <img class="arrows" src="/static/img/arrows.png" alt="">
          </li>
        </ul>
      </div>
      <div class="bottomMeuns">
        <div class="content">
            <span class="informBut" @click="sideMenusFn"><router-link to="/inform"><i
              class="iconfont icon-tongzhi"></i></router-link>
              <xk-badge-mod v-if="imformNum.content!==''" :text="imformNum.num"></xk-badge-mod>
            </span>
          <span class="shareBut" @click="sideMenusFn"><router-link to="/friend"><i
            class="iconfont icon-fenxiang"></i></router-link></span>
          <span class="setBut" @click="sideMenusFn"><router-link to="/settings"><i
            class="iconfont icon-shezhi"></i></router-link></span>
          <span class="contentText">邀请好友</span>
        </div>
      </div>
    </div>
    <div class="modal" @click="sideMenusFn">
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import XkBadgeMod from '../../badge/src/badge.vue'

  export default {
    components: {XkBadgeMod},
    name: 'xk-sideMenus',
    computed: {
      ...mapGetters({
        loginData: 'loginData',
        imformNum: 'imformNum',
        orderNav: 'orderNav'
      }),
      upImgFn: function () {
        if (this.loginData.passenger && this.loginData.passenger.avatar) {
          return window.configure.imgUrl + this.loginData.passenger.avatar
        } else {
          return false
        }
      }
    },
    data () {
      return {
        sideMenusState: false,
        headPortrait: null
      }
    },
    watch: {
      // sideMenusState (val) {
        // let that = this
        // if (val) {
          // that.$store.dispatch('checkLogin', (state) => {
          //   if (state) {
              // let imformNumFn = () => {
              //   that.$store.dispatch('imformNum', {
              //     'passengerId': that.loginData.passenger.id
              //   })
              // }
              // imformNumFn()
            // }
          // })
        // }
      // }
    },
    methods: {
      sideMenusFn: function () { // 点击模态框  收回个人中心
        console.log(1231231, this.loginData)
        let State = this.sideMenusState
        this.sideMenusState = !State
      },
      compileNomFn: function () {
        this.$router.push('/compileNom')
      }
    },
    mounted: function () {
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style rel="stylesheet/less" lang="less">

  .sideMenus {
    position: fixed;
    left: -110%;
    top: 0;
    height: 100%;
    z-index: -999;
    transition: 0.3s all;
    .sideMenusContent {
      box-sizing: border-box;
      width: 80vw;
      height: 100vh;
      background: #fff;
      position: relative;
      z-index: 555;
      /*padding-top: 5.25rem;*/
      .personInfo {
        padding: 0 1rem;
        /*height: 7.375rem;*/
        height: 238px;
        width: 100%;
        box-sizing: border-box;
        background: url("/static/img/userCenter_bg.png") no-repeat;
        background-size: cover;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        .personInfo-inner{
          width: 100%;
          position: relative;
          display: flex;
          justify-content: center;
        }
        .headImg {
          box-sizing: border-box;
          width: 76px;
          height: 76px;
          border-radius: 50%;
          overflow: hidden;
          img {
            width: 100%;
            height: 100%;
          }
        }
        .vipRank {
          position: absolute;
          font-size: 12px;
          bottom: -6px;
          background:rgba(0,0,0,0.63);
          font-weight:400;
          color:rgba(255,255,255,1);
          padding: 0 5px;
          border-radius: 3px;
          img{
            width: 10px;
            height: 10px;
            padding-right: 4px;
          }
        }
        .info {
          box-sizing: border-box;
          width: calc(~'100% - 7.375rem');
          /*padding-left: 1.3rem;*/
          padding-top: 12px;
          text-align: center;
          .infoName {
            font-size: 1.25rem;
            line-height: 2rem;
            font-weight: 400;
            color: #ffffff;
          }
          .phone {
            color: #999;
          }
        }

      }
      .menusOption {
        /*margin-top: 5rem;*/
        width: 100%;
        box-sizing: border-box;
        ul {
          width: 100%;
          box-sizing: border-box;
          padding: 0 12px;
          li {
            height: 53px;
            width: 100%;
            border-bottom: 1px #EBEBEB solid;
            position: relative;
            a {
              width: 100%;
              color: #333;
              height: 100%;
              line-height: 53px;
              display: flex;
              align-items: center;
              .text {
                font-size:15px;
                font-weight:400;
                color:rgba(34,34,34,1);
                line-height:21px;
              }
              i {
                margin-right: 8px;
                color: #72B8FF;
                font-size: 14px;
              }
              .icon{
                width: 16px;
                height: 16px;
                margin-right: 8px;
              }
            }
            .arrows{
              position: absolute;
              width: 6px;
              right: 0;
              bottom: 20px;
            }
          }
        }
      }
      .bottomMeuns {
        position: absolute;
        bottom: 0;
        left: 0;
        height: 5.08333rem;
        box-sizing: border-box;
        width: 100%;
        padding: 0 1rem;
        background: url(../../../../assets/img/yonghu/bottom_bg.png) no-repeat center bottom;
        background-size: auto 100%;
        .content {
          height: 100%;
          .informBut, .setBut, .shareBut, .contentText {
            a {
              border-radius: 50%;
              display: inline-block;
            }
          }
          .informBut, .setBut {
            position: absolute;
            top: 50%;
            transform: translate(0, -45%);
            a {
              width: 3.33333rem;
              height: 3.33333rem;
              border: 1px solid #d4d4d4;
              background: #fff;
              border-radius: 50%;
              position: relative;
              i {
                font-size: 1.4rem;
                position: absolute;
                left: 50%;
                top: 50%;
                color: #333;
                transform: translate(-50%, -50%);
              }
            }
          }
          .informBut {
            left: 1.43333rem;
            .badgeMod {
              position: absolute;
              right: -0.2rem;
              top: -0.2rem;
              border: 2px solid #E9E7E5;
            }
          }
          .setBut {
            right: 1.83333rem;
          }
          .shareBut {
            position: absolute;
            top: -2.4rem;
            left: 50%;
            transform: translate(-51%, 0);
            width: 5rem;
            height: 5rem;
            background: #f9554d;
            border-radius: 50%;
            overflow: hidden;
            a {
              width: 100%;
              height: 100%;
              i {
                position: absolute;
                left: 50%;
                top: 50%;
                transform: translate(-50%, -50%);
                color: #fff;
                font-size: 3rem;
              }
            }
          }
          .contentText {
            position: absolute;
            bottom: 0.4rem;
            left: 50%;
            transform: translate(-50%, 0);
            color: #514f4c;
            font-size: 1rem;
          }
        }
      }
    }
    .modal {
      width: 200%;
      height: 200%;
      opacity: 0;
      background-color: rgba(0, 0, 0, 0.5);
      position: fixed;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      z-index: -100;
      transition: 0.3s all;
    }
  }

  .showSideMenus {
    left: 0;
    top: 0;
    z-index: 999;
    .modal {
      opacity: 1;
      z-index: 300;
    }
  }
</style>



// WEBPACK FOOTER //
// sideMenus.vue?37b3388a